import React from 'react';

/*
  A small coloured badge saying what state something is in.

  Written 6 September 2026 for the Reports screens, by lifting the copy that
  lived inside `ReviewHubPage.jsx`. Both needed the same five tones and there is
  no reason for two of them. Group F's drawings show it on every row of two of
  the four reports.

  **It draws itself from the shared `.pill` rules since 11 September 2026**, job
  27 phase 3. It used to carry its own inline colours and its own size, so OnHand
  had two badges that did not match: this one was 10.5px in a 7px-radius box with
  no dot, and the other was a pill with one. The brand guide's section 9.3
  describes ONE badge, so there is one.

  Everything about how it looks now lives in `.pill` in index.css: 24 tall, a
  pill radius, the caps style, a tint behind, the ink shade on the word and a
  6px dot in the core colour.
*/

// The tone a caller asks for, and the class that draws it.
const TONE_CLASS = {
  app:      'pill-app',   // approved, in stock, saved
  gold:     'pill-ip',    // in progress
  ns:       'pill-ns',    // not started, not counted, nothing here yet
  blue:     'pill-sub',   // submitted, on order
  transfer: 'pill-sub',   // an ownership transfer. Violet was retired; a
                          // transfer reads from its icon and its words now
  red:      'pill-red',   // an error, a stockout, something that failed
};

export default function Pill({ children, tone }) {
  return <span className={'pill ' + (TONE_CLASS[tone] || 'pill-ns')}>{children}</span>;
}

/*
  How far along a count sheet is, in the four words OnHand uses everywhere else.
  The database spells them `not_started`, `in_progress`, `submitted` and
  `approved`; nobody using OnHand ever sees an underscore.
*/
export const SHEET_STATE = {
  not_started: { label: 'Not started', tone: 'ns' },
  // In progress is blue and Submitted gold, the brand guide's 11.4 (rebrand
  // step 3). They were the other way round.
  in_progress: { label: 'In progress', tone: 'blue' },
  submitted:   { label: 'Submitted',   tone: 'gold' },
  approved:    { label: 'Approved',    tone: 'app' },
};

export function SheetPill({ status }) {
  const s = SHEET_STATE[status];
  if (!s) return null;
  return <Pill tone={s.tone}>{s.label}</Pill>;
}
